import { createFileRoute } from '@tanstack/react-router'

import { CompanyPage } from '@/app/manager/CompanyPage/CompanyPage'
import { CompanyOverview } from '@/company/components/CompanyOverview/CompanyOverview'
import { buildPageTitle } from '@/core/utils/buildPageTitle/buildPageTitle'

export const Route = createFileRoute('/company/_management/')({
  head: () => ({
    meta: [
      {
        title: buildPageTitle({
          titleKey: 'page-title-company-overview',
        }),
      },
    ],
  }),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CompanyPage>
      <CompanyOverview />
    </CompanyPage>
  )
}
